import type { CashFundConfig } from '@shared/utils/cashFund/cashFund.types';

type WalletSpendQueryVariables = Readonly<{
  walletSpendEventId: string;
  includeWalletSpend: boolean;
}>;

/**
 * Whether a search should ask for each listing's fund/card split, and for which event.
 *
 * Only the cash-fund variant turns it on. Every other console (guest, admin, OTA, website editor)
 * sends `false`, so none of them pays for the block's cross-service balance read.
 *
 * Both search paths — the first snapshot fetch and the realtime refresh — must send the same
 * answer, or the refresh replaces the tiles with copies that have no split.
 */
export const buildWalletSpendQueryVariables = (cashFund: CashFundConfig | undefined): WalletSpendQueryVariables => ({
  // A non-null argument still needs a value when the field is skipped; the server never sees it.
  walletSpendEventId: cashFund?.eventId ?? '',
  includeWalletSpend: !!cashFund?.eventId,
});
